<template>
  <div v-if="permission || superUser" :value="$route.path" class="py-3">
    <v-card class="pa-3" v-if="permission || superUser" :value="$route.path">
      <v-card-title
        v-if="paymentMethods && !paymentMethods.length"
        class="d-flex text-h6 font-weight-bold justify-center pr-0 pl-0"
      >
        <span class="text-center pa-1" style="width: 100%">
          <template v-if="selectedMethod && selectedMethod.system_payment_method">
            <template v-if="selectedMethod.system_payment_method.image">
              <img
                :src="selectedMethod.system_payment_method.image"
                alt="Stripe"
                style="height: 24px; vertical-align: middle"
              />
            </template>
            <template v-else>
              {{ selectedMethod.system_payment_method.name[lang] }}
            </template>
          </template>
          <template v-else>
            {{ translations.paymentMethod[lang] }}
          </template>
        </span>
      </v-card-title>
      <v-card-text v-if="paymentMethods && !paymentMethods.length" class="body-1 text-center">
        {{ translations.noPaymentMethodNeededDescription[lang] }}
      </v-card-text>
      <v-row v-if="paymentMethods && paymentMethods.length" class="d-flex justify-center">
        <v-col cols="12" xl="12" md="12" v-if="selectedMethod">
          <v-card flat class="pb-2">
            <v-card-title class="text-h5 font-weight-bold justify-start pa-0">
              <span class="text-center pa-4">{{ translations.selectedMethod[lang] }}</span>
            </v-card-title>
            <v-row class="d-flex justify-center">
              <v-col cols="12" xl="3" lg="4" md="6" sm="6" xs="12">
                <v-card elevation="6" class="ml-2 mr-2">
                  <v-card-title class="subtitle-1 font-weight-bold justify-center pr-0 pl-0">
                    <span class="text-center pa-1" style="width: 100%">
                      <template v-if="selectedMethod.system_payment_method.image">
                        <img
                          :src="selectedMethod.system_payment_method.image"
                          :alt="getImageName(selectedMethod.system_payment_method.image)"
                          style="height: 24px; vertical-align: middle"
                        />
                      </template>
                      <template v-else>
                        {{ selectedMethod.system_payment_method.name[lang] }}
                      </template>
                    </span>
                  </v-card-title>
                  <v-card-text class="body-1 text-center">
                    {{ selectedMethod.system_payment_method.description[lang] }}
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" xl="3" lg="4" md="6" sm="6" xs="12">
                <v-card elevation="6" class="ml-2 mr-2">
                  <v-card-title class="subtitle-1 font-weight-bold justify-center pr-0 pl-0">
                    <span class="text-center pa-1" style="width: 100%">{{
                      translations.method[lang]
                    }}</span>
                  </v-card-title>
                  <v-card-text class="body-1 text-center">
                    <div class="d-flex flex-column justify-center align-center">
                      <div class="d-flex justify-center align-center">
                        <span class="pa-1 pl-6">
                          <template v-if="selectedMethod.system_payment_category.image">
                            <img
                              :src="selectedMethod.system_payment_category.image"
                              :alt="getImageName(selectedMethod.system_payment_category.image)"
                              style="height: 24px; vertical-align: middle"
                            />
                          </template>
                          <template v-else>
                            {{ selectedMethod.system_payment_category.name[lang] }}
                          </template>
                        </span>
                        <v-tooltip v-if="superUser" color="secondary" top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-if="superUser"
                              class="text-capitalize"
                              depressed
                              fab
                              x-small
                              v-on="on"
                              @click="
                                () => {
                                  changePaymentMethodDialog = true;
                                }
                              "
                            >
                              <v-icon size="20" v-text="icons.mdiSwapVertical"></v-icon>
                            </v-btn>
                          </template>
                          <span
                            class="font-weight-bold"
                            v-text="translations.paymentMethodChange[lang]"
                          ></span>
                        </v-tooltip>
                      </div>
                      <div
                        v-if="selectedMethod.system_payment_category.system !== 'payment_codes'"
                        class="d-flex flex-column justify-center align-center"
                      >
                        <span
                          v-for="(field, i) in Object.keys(
                            selectedMethod.store_payment_credentials || {}
                          )"
                          :key="i"
                        >
                          {{ field }}:
                          {{
                            selectedMethod.store_payment_credentials &&
                            selectedMethod.store_payment_credentials[field]
                          }}
                        </span>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" xl="3" lg="4" md="6" sm="6" xs="12">
                <v-card elevation="6" class="ml-2 mr-2">
                  <v-card-title class="subtitle-1 font-weight-bold justify-center pr-0 pl-0">
                    <span class="text-center pa-1" style="width: 100%">{{
                      translations.status[lang]
                    }}</span>
                  </v-card-title>
                  <v-card-text
                    class="body-1 text-center"
                    :class="{
                      'success--text': selectedMethod.status.includes('ok'),
                    }"
                  >
                    <v-icon
                      class="active-icon mr-2 error--text"
                      :class="{
                        'success--text': selectedMethod.status.includes('ok'),
                      }"
                      color="black"
                      size="15"
                      v-text="icons.mdiCheckboxBlankCircle"
                    ></v-icon>
                    {{ translations[`methodStatus_${selectedMethod.status}`][lang] }}
                  </v-card-text>
                  <v-col
                    v-if="selectedMethod.status == 'stripe_no_card'"
                    cols="12"
                    md="12"
                    class="d-flex flex-column justify-center pt-0 mt-0"
                  >
                    <v-divider></v-divider>
                    <v-btn
                      color="secondary"
                      class="text-capitalize px-5 mt-1"
                      depressed
                      :loading="loading"
                      type="submit"
                      @click="openAddCard"
                      >{{ translations.addCard[lang] }}</v-btn
                    >
                  </v-col>

                  <v-col
                    v-if="selectedMethod.status == 'stripe_authentication_required'"
                    cols="12"
                    md="12"
                    class="d-flex flex-column justify-center pt-0 mt-0"
                  >
                    <v-divider></v-divider>

                    <v-btn
                      color="red"
                      class="text-capitalize px-5 mt-1 white--text"
                      depressed
                      :loading="loading"
                      type="submit"
                      @click="authenticateStripePayment"
                      >{{ translations.authenticatePayment[lang] }}</v-btn
                    >
                  </v-col>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" xl="12" md="12" v-else>
          <v-card flat class="pb-2">
            <v-card-title class="text-h6 font-weight-bold justify-center pr-0 pl-0">
              <span
                class="text-center pa-1"
                style="background-color: #2a3042; color: white; width: 100%"
                >{{ translations.paymentMethod[lang] }}</span
              >
            </v-card-title>
            <v-card-text class="body-1 text-center error--text">
              {{ translations.choosePaymentMethodError[lang] }}
            </v-card-text>
            <v-radio-group v-model="chosenMethodId" inline>
              <v-row class="d-flex justify-center">
                <v-col
                  cols="12"
                  xl="3"
                  lg="4"
                  md="6"
                  sm="6"
                  xs="12"
                  v-for="method in paymentMethods"
                  :key="method.store_payment_method_id"
                >
                  <v-hover v-slot="{ hover }" class="pb-4">
                    <v-card
                      style="cursor: pointer; width: 100%; height: 100%"
                      :elevation="
                        chosenMethodId == method.store_payment_method_id || hover ? 18 : 4
                      "
                      :class="{
                        'on-hover': chosenMethodId == method.store_payment_method_id || hover,
                      }"
                    >
                      <v-radio
                        label="Option 1"
                        class="d-flex flex-column-reverse justify-center align-center label-width-100"
                        color="secondary"
                        style="height: 100%"
                        :value="method.store_payment_method_id"
                      >
                        <template v-slot:label>
                          <v-card flat style="width: 100%" class="mb-4">
                            <v-card-title
                              class="subtitle-1 font-weight-bold justify-center pr-0 pl-0"
                            >
                              <span class="text-center pa-1" style="width: 100%">{{
                                method.system_payment_method.name[lang]
                              }}</span>
                            </v-card-title>
                            <v-card-text
                              class="body-1 text-center d-flex flex-column justify-center align-center pb-0"
                            >
                              <span>{{ method.system_payment_method.description[lang] }}</span>
                              <v-divider></v-divider>

                              <span
                                v-for="(field, i) in Object.keys(
                                  method.store_payment_credentials || {}
                                )"
                                :key="i"
                              >
                                {{ field }}:
                                {{
                                  method.store_payment_credentials &&
                                  method.store_payment_credentials[field]
                                }}
                              </span>
                            </v-card-text>
                          </v-card>
                        </template>
                      </v-radio>
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>
            </v-radio-group>
            <v-row class="d-flex justify-end flex-column align-end">
              <v-col cols="12" xl="3" lg="4" md="6" sm="6" xs="12">
                <v-btn
                  :color="'secondary'"
                  class="text-capitalize px-5"
                  style="font-size: 0.9rem; width: 100%"
                  depressed
                  :loading="loading"
                  :disabled="!chosenMethodId"
                  @click="submitMethod"
                  >{{ translations.submit[lang] }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col
          v-if="
            selectedMethod &&
            selectedMethod.store_payment_credentials &&
            selectedMethod.store_payment_credentials.payment_code
          "
          cols="12"
          xl="12"
          md="12"
        >
          <v-card elevation="12">
            <v-card-text class="text-h5">
              <span class="text-center text-h5 text--primary pa-0 ma-0" style="width: 100%"
                ><p class="mb-1">
                  {{ translations.billingCompleted[lang] }}
                </p>
                <p class="mb-1">{{ translations.useCodeBelowTopay[lang] }}:</p>
                <p class="text-h6 font-weight-black mb-0">
                  <span class="pl-1 pr-1" style="background-color: paleturquoise">{{
                    selectedMethod.store_payment_credentials.payment_code
                  }}</span>
                </p></span
              >
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          xl="12"
          md="12"
          v-if="selectedMethod && selectedMethod.system_payment_category.system == 'stripe'"
        >
          <v-card elevation="12">
            <v-card-title class="text-h6 font-weight-bold justify-center pr-0 pl-0">
              <span
                class="text-center pa-1"
                style="background-color: #2a3042; color: white; width: 100%"
                >{{ translations.paymentMethods[lang] }}</span
              >
            </v-card-title>

            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr v-if="paymentCards && paymentCards.length">
                    <th
                      class="text-center"
                      :style="{ width: header.width }"
                      v-for="(header, i) in cardsTableHeaders"
                      :key="i"
                    >
                      {{ header.text }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="text-center" v-for="card in paymentCards" :key="card.id">
                    <td>
                      <span style="white-space: pre">
                        <template v-if="card.type === 'card'">
                          <v-icon
                            color="secondary"
                            x-large
                            v-text="icons.mdiCreditCardOutline"
                          ></v-icon>
                        </template>
                        <template v-else-if="card.type === 'sepa_debit'">
                          <img
                            src="@/assets/sepa.svg"
                            alt="SEPA"
                            style="height: 24px; vertical-align: middle"
                          />
                        </template>
                        <template v-else>
                          {{ card.type }}
                        </template>
                      </span>
                    </td>
                    <td>
                      <span style="white-space: pre">{{ '****\t****\t****\t' + card.last4 }}</span>
                    </td>
                    <td>
                      <v-icon
                        v-if="card.active"
                        class="active-icon success--text"
                        color="black"
                        v-text="icons.mdiCheck"
                      ></v-icon>
                    </td>
                    <td>
                      <v-tooltip color="secondary" top>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" v-show="!card.active" icon @click="activateMethod(card)">
                            <v-icon v-text="icons.mdiCreditCardCheckOutline"></v-icon>
                          </v-btn>
                        </template>

                        <span class="font-weight-bold" v-text="translations.activate[lang]"></span>
                      </v-tooltip>
                      <v-tooltip color="secondary" top>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" icon @click="opendeleteMethodDialog(card)">
                            <v-icon v-text="icons.mdiDelete"></v-icon>
                          </v-btn>
                        </template>
                        <span class="font-weight-bold" v-text="translations.delete[lang]"></span>
                      </v-tooltip>
                    </td>
                  </tr>
                  <tr class="text-center"></tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-row class="d-flex justify-center flex-column align-center">
              <v-col cols="12" md="5">
                <v-btn
                  color="secondary"
                  class="text-capitalize px-5"
                  style="width: 100%"
                  depressed
                  :loading="loading"
                  type="submit"
                  @click="addStripeMethod"
                  >{{ translations.addPaymentMethod[lang] }}</v-btn
                >
              </v-col>
              <v-divider></v-divider>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="addCardDialog" max-width="500">
      <b-card
        :title="translations.addPaymentMethod[lang]"
        :loading="loading"
        :error-message="errorMessage"
        :submit-text="{ el: 'Προσθήκη', en: 'Add', it: 'Aggiungi' }"
        @cancel="addCardDialog = false"
        @submit="confirmCardAdding()"
      >
        <div id="payment-element"></div>
      </b-card>
    </v-dialog>

    <v-dialog v-model="deleteMethodDialog" max-width="500">
      <b-card
        type="delete"
        :title="translations.deleteMethodTitle[lang]"
        :loading="loading"
        :error-message="errorMessage"
        :submit-text="translations.delete"
        @cancel="deleteMethodDialog = false"
        @submit="deleteMethod()"
      >
        <div class="subtitle-1 font-weight-medium pl-2">
          {{ translations.deleteMethodQuestion[lang] }}
        </div>
      </b-card>
    </v-dialog>

    <v-dialog v-model="stripeAuthMessageDialog" max-width="500">
      <b-card hideDefaultFooter @cancel="closeStripeAuthMessageDialog()">
        <iframe
          :src="stripeAuthMessageUrl"
          frameborder="0"
          style="width: 100%; height: 400px"
        ></iframe>
      </b-card>
    </v-dialog>

    <v-dialog v-model="changePaymentMethodDialog" max-width="500">
      <b-card
        v-if="superUser"
        :title="translations.paymentMethodChange[lang]"
        :loading="loading"
        :error-message="''"
        :submit-text="translations.submit"
        @cancel="changePaymentMethodDialog = false"
        @submit="changePaymentMethod(newPaymentMethodId)"
      >
        <div class="subtitle-1 font-weight-medium pl-2">
          {{ translations.paymentMethod[lang] }}
        </div>
        <v-row no-gutters class="mt-3 mb-1">
          <v-col cols="12">
            <b-select
              :items="availablePaymentMethods"
              item-text="name"
              item-value="store_payment_method_id"
              :label="translations.paymentMethod[lang]"
              v-model="newPaymentMethodId"
            ></b-select>
          </v-col>
        </v-row>
      </b-card>
    </v-dialog>

    <div class="grey-overlay" v-if="showOverlay">
      <v-progress-circular indeterminate></v-progress-circular>
    </div>

    <div class="grey-overlay" v-if="overlayWithoutLoading"></div>
  </div>
</template>

<script>
import {
  mdiCheckboxBlankCircle,
  mdiCheck,
  mdiDelete,
  mdiCreditCardCheckOutline,
  mdiSwapVertical,
  mdiCreditCardOutline,
} from '@mdi/js';
import { mapState, mapMutations, mapActions } from 'vuex';

import translations from '@/utils/translations/general/settings/billingDashboard';

export default {
  name: 'BillingDashboardPaymentMethods',

  components: {},

  mixins: [translations],

  data() {
    return {
      tab: this.$route.path,
      icons: {
        mdiDelete,
        mdiCheckboxBlankCircle,
        mdiCheck,
        mdiCreditCardCheckOutline,
        mdiSwapVertical,
        mdiCreditCardOutline,
      },
      store_payment_method_id: null,
      deletingMethod: null,
      addCardDialog: false,
      stripeAuthMessageUrl: '',
      stripeAuthMessageDialog: false,
      showOverlay: false,
      overlayWithoutLoading: false,
      elements: null,
      stripe: null,
      deleteMethodDialog: false,
      chosenMethodId: null,
      changePaymentMethodDialog: false,
      newPaymentMethodId: null,
      generalErrorText: {
        el: 'Υπήρξε κάποιο σφάλμα, παρακαλώ δοκιμάστε ξανά αργότερα',
        en: 'There was an error, please try again later',
        it: 'Si è verificato un errore, riprovare più tardi',
      },
    };
  },

  computed: {
    ...mapState(['loading', 'errorMessage', 'superUser']),

    ...mapState('general/settings/billingDashboard/paymentMethods', [
      'paymentMethods',
      'selectedMethod',
      'paymentCards',
      'stripeSessionData',
      'authDetails',
    ]),

    lang() {
      return this.$route.params.lang;
    },

    permission() {
      return (
        this.superUser ||
        (this.$store.state.permissions.general_settings
          ? this.$store.state.permissions.general_settings.billing_dashboard.read
          : null)
      );
    },

    cardsTableHeaders() {
      return [
        {
          text: this.translations.type[this.lang],
          value: 'type',
          width: '15%',
        },
        {
          text: this.translations.cardNumber[this.lang],
          value: 'last4',
          width: '40%',
        },
        {
          text: this.translations.active[this.lang],
          value: 'active',
          width: '15%',
        },
        {
          text: this.translations.actions[this.lang],
          value: 'actions',
          width: '30%',
        },
      ];
    },
    availablePaymentMethods() {
      return (
        (this.paymentMethods &&
          this.paymentMethods.length &&
          this.paymentMethods.filter((e) => !e.selected)) ||
        []
      );
    },
  },

  methods: {
    ...mapMutations(['setNotification', 'setLoading']),

    ...mapActions('general/settings/billingDashboard', ['fetchBillingDashboardData']),

    ...mapActions('general/settings/billingDashboard/paymentMethods', [
      'getPaymentMethods',
      'getStripeMethods',
      'deletePaymentCard',
      'chooseMethod',
      'doStripeAction',
      'addStripeMethod',
      'authenticatePayment',
      'updatePaymentMethod',
    ]),

    closeStripeAuthMessageDialog() {
      this.showOverlay = false;
      this.stripeAuthMessageDialog = false;
      window.location.reload();
    },

    async changePaymentMethod(id) {
      let res = await this.updatePaymentMethod(id);
      if (res.code == 200) {
        await this.getPaymentMethods();
      }
      this.changePaymentMethodDialog = false;
      this.fetchBillingDashboardData();
    },

    async submitMethod() {
      let chosenMethod = await this.chooseMethod(this.chosenMethodId);
      if (!chosenMethod || chosenMethod.error) {
        this.setNotification({
          show: true,
          type: 'error',
          text: this.generalErrorText[this.lang],
        });
        return;
      }
      let successText = {
        el: 'Η μέθοδος πληρωμής επιλέχθηκε επιτυχώς',
        en: 'Payment method selected successfully',
        it: 'Metodo di pagamento selezionato con successo',
      };
      this.setNotification({
        show: true,
        type: 'success',
        text: successText[this.lang],
      });
      this.fetchBillingDashboardData();
    },

    async activateMethod(method) {
      let res = await this.doStripeAction({ action: 'patch', method });
      if (!res || res.error) {
        this.setNotification({
          show: true,
          type: 'error',
          text: this.generalErrorText[this.lang],
        });
        return;
      }
      await this.getStripeMethods();

      let successText = {
        el: 'Η κάρτα ενεργοποιήθηκε επιτυχώς.',
        en: 'The card has been successfully activated',
        it: 'La carta è stata attivata con successo',
      };
      this.setNotification({
        show: true,
        type: 'success',
        text: successText[this.lang],
      });
    },

    opendeleteMethodDialog(method) {
      this.deleteMethodDialog = true;
      this.deletingMethod = method;
    },

    async deleteMethod() {
      let res = await this.doStripeAction({
        action: 'delete',
        method: this.deletingMethod,
      });
      await this.getPaymentMethods();
      await this.getStripeMethods();
      if (!res || res.error) {
        this.setNotification({
          show: true,
          type: 'error',
          text: this.generalErrorText[this.lang],
        });
        return;
      }

      this.deleteMethodDialog = false;
      let successText = {
        el: 'Η κάρτα διαγράφηκε επιτυχώς.',
        en: 'The card has been successfully deleted',
        it: 'La scheda è stata cancellata con successo',
      };
      this.setNotification({
        show: true,
        type: 'success',
        text: successText[this.lang],
      });
    },

    async authenticateStripePayment() {
      this.showOverlay = true;
      await this.authenticatePayment();
      try {
        const stripe = window.Stripe(this.authDetails.public_key);
        this.stripeAuthMessageDialog = true;
        stripe
          .confirmCardPayment(this.authDetails.client_secret, {
            payment_method: this.authDetails.payment_method_id,
          })
          .then((result) => {
            if (result.error) {
              this.stripeAuthMessageUrl = this.authDetails.cancel_url;
            } else {
              this.stripeAuthMessageUrl = this.authDetails.success_url;
            }
            this.stripeAuthMessageDialog = true;
            this.showOverlay = false;
          });
      } catch (e) {
        console.log(e);
        this.stripeAuthMessageDialog = false;
        this.showOverlay = false;
        this.setNotification({
          show: true,
          type: 'error',
          text: this.generalErrorText[this.lang],
        });
      }
    },

    async confirmCardAdding() {
      const { error } = await this.stripe.confirmSetup({
        elements: this.elements,
        redirect: 'if_required',
      });

      if (error) {
        this.addCardDialog = false;
        this.overlayWithoutLoading = false;
        this.setNotification({
          show: true,
          type: 'error',
          text: this.generalErrorText[this.lang],
        });
      } else {
        this.stripeAuthMessageUrl = this.stripeSessionData.return_url;
        this.addCardDialog = false;
        this.stripeAuthMessageDialog = true;
      }
    },

    async openAddCard() {
      this.addCardDialog = true;
      await this.addStripeMethod();
      if (!this.stripeSessionData) {
        this.addCardDialog = false;
      }
    },
    getImageName(imagePath) {
      if (!imagePath) return '';
      const parts = imagePath.split('/').pop().split('.');
      const name = parts[0];
      return name.charAt(0).toUpperCase() + name.slice(1);
    },
  },

  watch: {
    permission: {
      // immediate: true,
      handler(val) {
        if (!val && !this.superUser) {
          this.$router.replace(`/${this.lang}/storePanel/forbidden-gateway`);
        }
      },
    },

    selectedMethod: {
      immediate: true,
      handler(val) {
        if (val?.system_payment_category?.system == 'stripe') {
          this.getStripeMethods();
          //    if (!val.system_payment_method.icon) {
          // Assuming you imported the SVG as stripeIcon
          val.system_payment_method.image = require('@/assets/stripe.svg');
          val.system_payment_category.image = val.system_payment_method.image;
          // }
        }
      },
    },

    stripeSessionData(data) {
      if (data && data.client_secret && data.public_key && data.return_url) {
        this.addCardDialog = true;
        this.stripe = window.Stripe(data.public_key);

        const options = {
          clientSecret: data.client_secret,
        };

        this.elements = this.stripe.elements(options);
        const paymentElement = this.elements.create('payment');
        setTimeout(() => {
          paymentElement.mount('#payment-element');
        }, 1000);
      } else {
        this.addCardDialog = false;
      }
    },
  },
};
</script>
<style lang="sass">
.v-card.on-hover
  background-color: rgba(#FFF, 0.8)
  >.v-card__text
    color: #000
</style>
<style>
.grey-overlay {
  background-color: #5e5e5ecc;
  z-index: 101;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
}

.dashed {
  border: 1px dashed grey;
  border-radius: 10px;
}

.relative {
  position: relative;
}

.theme--light.v-tabs > .v-tabs-bar {
  width: 100%;
}

.v-tabs-bar.v-item-group > * {
  width: 100%;
}

.v-slide-group__content {
  width: 100%;
}

.my-subscription {
  background-color: #2a3042;
  color: white !important;
  border-radius: 5px 5px 0px 0px;
}
.v-radio.label-width-100 .v-label {
  width: 100% !important;
}
</style>
